// 職種マスタデータ (jCd)
// Generated from API1.13_20240325 05_職種マスタ
export const jobTypeData = [
  {
    label: '経営',
    jgCd: 'JG001',
    options: [
      { label: '経営者・CEO・COO等', value: 'J0001' },
      { label: 'CTO・CIO', value: 'J0040' },
      { label: 'CFO', value: 'J0006' },
      { label: '事業企画・事業統括', value: 'J0002' },
      { label: '経営企画・経営戦略', value: 'J0003' },
      { label: '新規事業企画・事業開発', value: 'J0004' },
      { label: 'M&A・合併・提携', value: 'J0005' }
    ]
  },
  {
    label: '管理',
    jgCd: 'JG002',
    options: [
      { label: '経理（財務会計）', value: 'J0008' },
      { label: '財務', value: 'J0007' },
      { label: '管理会計', value: 'J0113' },
      { label: '税務', value: 'J0114' },
      { label: 'IR', value: 'J0013' },
      { label: '内部監査・内部統制', value: 'J0009' },
      { label: '法務・コンプライアンス', value: 'J0011' },
      { label: '知的財産・特許', value: 'J0115' },
      { label: '総務', value: 'J0010' },
      { label: '秘書', value: 'J0116' },
      { label: '物流企画・物流管理', value: 'J0015' },
      { label: '購買・資材調達', value: 'J0105' },
      { label: '商品・在庫管理', value: 'J0117' },
      { label: '国際・貿易業務', value: 'J0014' },
      { label: '翻訳・通訳', value: 'J0118' }
    ]
  },
  {
    label: '人事',
    jgCd: 'JG017',
    options: [
      { label: '採用', value: 'J0012' },
      { label: '人材開発・人材育成・研修', value: 'J0119' },
      { label: '制度企画・組織開発', value: 'J0120' },
      { label: '労務・給与', value: 'J0121' }
    ]
  },
  {
    label: '営業',
    jgCd: 'JG004',
    options: [
      { label: '法人営業', value: 'J0022' },
      { label: '個人営業', value: 'J0122' },
      { label: '営業企画', value: 'J0027' },
      { label: '営業事務・アシスタント', value: 'J0123' },
      { label: '代理店営業・アライアンス', value: 'J0023' },
      { label: 'ルートセールス・渉外・外商', value: 'J0124' },
      { label: '営業支援・プリセールス', value: 'J0025' },
      { label: 'インサイドセールス・内勤営業', value: 'J0125' },
      { label: '海外営業', value: 'J0024' },
      { label: 'キャリアコンサルタント・キャリアカウンセラー', value: 'J0126' },
      { label: 'コールセンター管理・運営（SV）', value: 'J0127' },
      { label: 'カスタマーサポート・ヘルプデスク', value: 'J0128' }
    ]
  },
  {
    label: 'マーケティング',
    jgCd: 'JG003',
    options: [
      { label: '広報・PR・広告宣伝', value: 'J0016' },
      { label: 'リサーチ・データ分析', value: 'J0017' },
      { label: '商品企画', value: 'J0018' },
      { label: '商品開発', value: 'J0129' },
      { label: '販促', value: 'J0019' },
      { label: 'MD・VMD', value: 'J0021' },
      { label: '仕入れ・バイヤー', value: 'J0130' }
    ]
  },
  {
    label: 'サービス',
    jgCd: 'JG018',
    options: [
      { label: '店舗・FC開発', value: 'J0026' },
      { label: '店舗管理・店舗運営', value: 'J0131' },
      { label: '店長', value: 'J0132' },
      { label: '介護福祉士', value: 'J0133' }
    ]
  },
  {
    label: 'コンサルタント',
    jgCd: 'JG005',
    options: [
      { label: '戦略コンサルタント', value: 'J0028' },
      { label: '財務・会計コンサルタント', value: 'J0029' },
      { label: '組織・人事コンサルタント', value: 'J0030' },
      { label: '業務プロセスコンサルタント', value: 'J0031' },
      { label: '物流コンサルタント', value: 'J0032' },
      { label: 'マーケティングコンサルタント', value: 'J0033' },
      { label: 'リサーチャー・調査員', value: 'J0134' }
    ]
  },
  {
    label: '専門職',
    jgCd: 'JG007',
    options: [
      { label: '公認会計士', value: 'J0038' },
      { label: '税理士', value: 'J0135' },
      { label: '弁護士', value: 'J0039' },
      { label: '弁理士', value: 'J0136' },
      { label: '知財管理・行政書士', value: 'J0137' },
      { label: '講師・トレーナー', value: 'J0110' },
      { label: '教授・准教授・教諭', value: 'J0138' }
    ]
  },
  {
    label: 'プロジェクト管理',
    jgCd: 'JG019',
    options: [
      { label: 'プロジェクトマネージャー（Web・オープン系）', value: 'J0041' },
      { label: 'プロジェクトマネージャー（汎用系）', value: 'J0042' },
      { label: 'プロジェクトマネージャー（制御・組み込み系）', value: 'J0043' },
      { label: 'プロジェクトリーダー（Web・オープン系）', value: 'J0139' },
      { label: 'プロジェクトリーダー（汎用系）', value: 'J0140' },
      { label: 'プロジェクトリーダー（制御・組み込み系）', value: 'J0141' }
    ]
  },
  {
    label: 'IT技術職',
    jgCd: 'JG008',
    options: [
      { label: 'SE（Web・オープン系）', value: 'J0044' },
      { label: 'SE（汎用系）', value: 'J0045' },
      { label: 'SE（制御・組み込み系）', value: 'J0046' },
      { label: 'フロントエンドエンジニア', value: 'J0142' },
      { label: 'インフラエンジニア', value: 'J0143' },
      { label: 'スマートフォンアプリエンジニア', value: 'J0144' },
      { label: 'パッケージ開発', value: 'J0145' },
      { label: '情報システム・社内SE', value: 'J0052' },
      { label: '運用・保守・監視・テクニカルサポート', value: 'J0051' },
      { label: 'サーバーエンジニア（構築・運用）', value: 'J0047' },
      { label: 'ネットワークエンジニア', value: 'J0146' },
      { label: 'データベースエンジニア', value: 'J0048' },
      { label: 'プリセールス・セールスエンジニア', value: 'J0049' },
      { label: '製品エンジニア（ハードウェア・ソフトウェア）', value: 'J0050' },
      { label: 'データサイエンティスト', value: 'J0147' },
      { label: 'その他（ローカリゼーション・QA等）', value: 'J0054' }
    ]
  },
  {
    label: 'ITコンサルタント',
    jgCd: 'JG006',
    options: [
      { label: 'システムコンサルタント', value: 'J0034' },
      { label: 'パッケージ導入コンサルタント', value: 'J0035' },
      { label: 'セキュリティコンサルタント', value: 'J0036' },
      { label: 'ネットワークコンサルタント', value: 'J0037' }
    ]
  },
  {
    label: 'Webサービス・制作',
    jgCd: 'JG020',
    options: [
      { label: 'Webプロデューサー・ディレクター', value: 'J0053' },
      { label: 'Webコンテンツ企画・編集・ライティング', value: 'J0148' },
      { label: 'Webデザイナー・UI/UXデザイナー', value: 'J0149' },
      { label: 'アートディレクター', value: 'J0150' },
      { label: 'プロダクトマネージャー', value: 'J0151' },
      { label: 'ECサイト運営・ECコンサルタント', value: 'J0152' }
    ]
  },
  {
    label: 'デジタルマーケティング',
    jgCd: 'JG021',
    options: [
      { label: 'Web広告運用・SEO', value: 'J0020' },
      { label: 'CRM', value: 'J0153' }
    ]
  },
  {
    label: 'ゲーム',
    jgCd: 'JG009',
    options: [
      {
        label: 'ゲームプロデューサー・ディレクター・プランナー',
        value: 'J0055'
      },
      { label: 'ゲームデザイナー', value: 'J0154' },
      { label: 'ゲームプログラマー', value: 'J0056' },
      { label: 'その他', value: 'J0155' }
    ]
  },
  {
    label: '広告',
    jgCd: 'JG022',
    options: [
      { label: 'プロデューサー・ディレクター', value: 'J0156' },
      { label: 'メディアプランナー', value: 'J0157' },
      { label: 'クリエイティブ・アートディレクター', value: 'J0158' },
      { label: 'デザイナー', value: 'J0159' },
      { label: 'コピーライター', value: 'J0160' }
    ]
  },
  {
    label: '新聞・出版',
    jgCd: 'JG023',
    options: [
      { label: '編集', value: 'J0161' },
      { label: '記者・ライター', value: 'J0162' }
    ]
  },
  {
    label: 'テレビ・放送・映像・音響',
    jgCd: 'JG024',
    options: [
      { label: 'プロデューサー・ディレクター', value: 'J0163' },
      { label: '映像制作・編集', value: 'J0164' }
    ]
  },
  {
    label: 'デザイン',
    jgCd: 'JG025',
    options: [
      { label: 'プロダクト・工業デザイナー', value: 'J0165' },
      { label: 'インテリアデザイナー', value: 'J0166' },
      { label: 'ファッションデザイナー', value: 'J0167' },
      { label: '空間・店舗デザイナー', value: 'J0168' },
      { label: 'その他', value: 'J0169' }
    ]
  },
  {
    label: '電気・電子',
    jgCd: 'JG010',
    options: [
      { label: '研究・開発', value: 'J0057' },
      { label: '回路・実装設計', value: 'J0058' },
      { label: '電気・電子制御設計', value: 'J0059' },
      { label: '生産技術', value: 'J0060' },
      { label: '生産管理', value: 'J0061' },
      { label: '品質管理', value: 'J0170' },
      { label: '品質保証', value: 'J0171' },
      { label: '工場長', value: 'J0172' },
      { label: 'セールス・サービスエンジニア', value: 'J0062' }
    ]
  },
  {
    label: '機械',
    jgCd: 'JG012',
    options: [
      { label: '研究・開発', value: 'J0068' },
      { label: '機械設計', value: 'J0069' },
      { label: '電気・電子制御設計', value: 'J0070' },
      { label: '生産技術', value: 'J0071' },
      { label: '生産管理', value: 'J0072' },
      { label: '品質管理', value: 'J0173' },
      { label: '品質保証', value: 'J0174' },
      { label: '工場長', value: 'J0175' },
      { label: 'セールス・サービスエンジニア', value: 'J0073' }
    ]
  },
  {
    label: '半導体',
    jgCd: 'JG011',
    options: [
      { label: '研究・開発', value: 'J0063' },
      { label: '半導体設計', value: 'J0064' },
      { label: '生産技術', value: 'J0065' },
      { label: '生産管理', value: 'J0066' },
      { label: '品質管理', value: 'J0176' },
      { label: '品質保証', value: 'J0177' },
      { label: '工場長', value: 'J0178' },
      { label: 'FAE・フィールドエンジニア', value: 'J0067' }
    ]
  },
  {
    label: '化学',
    jgCd: 'JG013',
    options: [
      { label: '研究・開発', value: 'J0074' },
      { label: '生産技術', value: 'J0075' },
      { label: '生産管理', value: 'J0076' },
      { label: '品質管理', value: 'J0179' },
      { label: '品質保証', value: 'J0180' },
      { label: '工場長', value: 'J0181' },
      { label: 'セールス・サービスエンジニア', value: 'J0077' }
    ]
  },
  {
    label: '素材',
    jgCd: 'JG026',
    options: [
      { label: '研究・開発', value: 'J0182' },
      { label: '生産技術', value: 'J0183' },
      { label: '生産管理', value: 'J0184' },
      { label: '品質管理', value: 'J0185' },
      { label: '品質保証', value: 'J0186' },
      { label: '工場長', value: 'J0187' },
      { label: 'セールス・サービスエンジニア', value: 'J0188' }
    ]
  },
  {
    label: '食品',
    jgCd: 'JG027',
    options: [
      { label: '研究・開発', value: 'J0189' },
      { label: '生産技術', value: 'J0190' },
      { label: '生産管理', value: 'J0191' },
      { label: '品質管理', value: 'J0192' },
      { label: '品質保証', value: 'J0193' },
      { label: '工場長', value: 'J0194' }
    ]
  },
  {
    label: '化粧品',
    jgCd: 'JG028',
    options: [
      { label: '研究・開発', value: 'J0195' },
      { label: '生産技術', value: 'J0196' },
      { label: '生産管理', value: 'J0197' },
      { label: '品質管理', value: 'J0198' },
      { label: '品質保証', value: 'J0199' },
      { label: '工場長', value: 'J0200' }
    ]
  },
  {
    label: '日用品',
    jgCd: 'JG029',
    options: [
      { label: '研究・開発', value: 'J0201' },
      { label: '生産技術', value: 'J0202' },
      { label: '生産管理', value: 'J0203' },
      { label: '品質管理', value: 'J0204' },
      { label: '品質保証', value: 'J0205' },
      { label: '工場長', value: 'J0206' }
    ]
  },
  {
    label: '金融',
    jgCd: 'JG014',
    options: [
      { label: '法人営業', value: 'J0078' },
      { label: '個人営業・FP', value: 'J0081' },
      { label: '代理店営業・パートナーセールス', value: 'J0079' },
      { label: 'ディーラー・トレーダー', value: 'J0082' },
      { label: 'ファンドマネージャー', value: 'J0083' },
      { label: 'プライベートバンカー', value: 'J0080' },
      { label: 'クオンツアナリスト', value: 'J0084' },
      { label: 'アクチュアリー', value: 'J0085' },
      { label: '金融商品開発', value: 'J0086' },
      { label: 'アナリスト', value: 'J0093' },
      { label: 'エコノミスト', value: 'J0094' },
      { label: 'ストラテジスト', value: 'J0095' },
      { label: '金融システム', value: 'J0207' },
      { label: '金融事務（業務・管理）', value: 'J0096' },
      { label: 'リーガル・コンプライアンス', value: 'J0097' },
      { label: 'リスク・与信・債権管理', value: 'J0111' },
      { label: '決済', value: 'J0112' },
      { label: 'カストディ業務', value: 'J0208' },
      { label: '受渡', value: 'J0209' },
      { label: '信託・鑑定', value: 'J0210' },
      { label: '公開・引受', value: 'J0087' },
      { label: 'M&A', value: 'J0088' },
      { label: 'PE', value: 'J0108' },
      { label: 'コーポレートファイナンス', value: 'J0089' },
      { label: 'ストラクチャードファイナンス', value: 'J0090' },
      { label: 'プロジェクトファイナンス', value: 'J0091' },
      { label: '財務アドバイザリー', value: 'J0092' },
      { label: '不動産金融', value: 'J0211' }
    ]
  },
  {
    label: '不動産',
    jgCd: 'JG030',
    options: [
      { label: '不動産企画・不動産開発', value: 'J0104' },
      { label: '用地仕入', value: 'J0212' },
      { label: '不動産鑑定・デューデリジェンス', value: 'J0213' },
      { label: 'アセットマネジメント', value: 'J0109' },
      { label: 'プロパティマネジメント', value: 'J0214' },
      { label: 'リーシング', value: 'J0215' },
      { label: '不動産・マンション・ビル管理', value: 'J0216' }
    ]
  },
  {
    label: '建築・土木',
    jgCd: 'JG016',
    options: [
      { label: '建設コンサルタント', value: 'J0217' },
      { label: '測量', value: 'J0218' },
      { label: '建築設計', value: 'J0219' },
      { label: '内装設計', value: 'J0220' },
      { label: '土木設計', value: 'J0221' },
      { label: 'プラント設計', value: 'J0222' },
      { label: '電気設備設計', value: 'J0223' },
      { label: '空調設備設計', value: 'J0224' },
      { label: 'その他', value: 'J0225' },
      { label: '製図・CADオペレーター', value: 'J0226' },
      { label: '積算', value: 'J0227' },
      { label: '設計監理', value: 'J0106' },
      { label: '構造解析', value: 'J0228' }
    ]
  },
  {
    label: '施工管理',
    jgCd: 'JG031',
    options: [
      { label: '建築施工管理', value: 'J0107' },
      { label: '内装施工管理', value: 'J0229' },
      { label: 'リフォーム施工管理', value: 'J0230' },
      { label: '土木施工管理', value: 'J0231' },
      { label: 'プラント施工管理', value: 'J0232' },
      { label: '電気設備施工管理', value: 'J0233' },
      { label: '空調設備施工管理', value: 'J0234' },
      { label: 'その他', value: 'J0235' }
    ]
  },
  {
    label: '医療営業',
    jgCd: 'JG032',
    options: [
      { label: 'MR', value: 'J0103' },
      { label: '医療機器営業', value: 'J0236' },
      { label: 'MSL（メディカル・サイエンス・リエゾン）', value: 'J0237' },
      { label: 'マーケティング・企画', value: 'J0238' },
      { label: 'その他', value: 'J0239' }
    ]
  },
  {
    label: '研究・臨床開発・治験',
    jgCd: 'JG015',
    options: [
      { label: '研究', value: 'J0098' },
      { label: '非臨床研究', value: 'J0240' },
      { label: '臨床開発', value: 'J0099' },
      { label: 'CRA（臨床開発モニター）', value: 'J0241' },
      { label: '統計解析・SASプログラマー', value: 'J0242' },
      { label: 'GCP・GLP監査', value: 'J0243' },
      { label: 'メディカルライティング', value: 'J0244' },
      { label: 'PV（安全性情報担当）', value: 'J0245' }
    ]
  },
  {
    label: '生産管理・品質管理・品質保証',
    jgCd: 'JG033',
    options: [
      { label: '生産技術・生産管理・製造技術', value: 'J0100' },
      { label: 'QC（品質管理）', value: 'J0246' },
      { label: 'QA（品質保証）', value: 'J0247' },
      { label: '知的財産', value: 'J0248' }
    ]
  },
  {
    label: '学術・PMS・薬事',
    jgCd: 'JG034',
    options: [
      { label: '学術', value: 'J0249' },
      { label: 'PMS（市販後調査）', value: 'J0250' },
      { label: '薬事', value: 'J0101' }
    ]
  },
  {
    label: '医療・看護・薬剤',
    jgCd: 'JG035',
    options: [
      { label: '医師', value: 'J0102' },
      { label: '看護師', value: 'J0251' },
      { label: '薬剤師・管理薬剤師', value: 'J0252' },
      { label: '臨床検査技師', value: 'J0253' }
    ]
  }
]
